<template>

    <div class="hfc">

        <div class="comic-bubble">
            <span>{{text}}</span>
            <img src="/img/newsletters-v2/bubble-arrow.svg" class="comic-bubble-arrow">
        </div>

        <div class="anim-container">
            <lottie-foxy-happy-card  class="anim-content" :autoplay="true" :loop="true"></lottie-foxy-happy-card>
        </div>

    </div>

</template>

<script>

import LottieFoxyHappyCard from '../../lottie/LottieFoxyHappyCard'
export default {

    name: 'happy-foxy-card',

    props: {
        text: {
            type: String,
            default: ''
        }
    },

    components: {
        LottieFoxyHappyCard
    }

}

</script>

<style lang="scss" scoped>

.hfc {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    border-radius: 12px;
    background: linear-gradient(204deg, #229AB1 36.84%, #3F9F6A 79.94%);
    box-shadow: 0 8px 32px 0 rgba(17, 17, 26, 0.05), 0 4px 16px 0 rgba(17, 17, 26, 0.1);
    padding: 32px 24px 0;

    .comic-bubble {
        display: flex;
        padding: 16px 12px;
        text-align: center;
        justify-content: center;
        width: 100%;
        background-color: $white;
        border-radius: 16px;
        font-size: 17px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        position: relative;
    }

    .comic-bubble-arrow {
        position: absolute;
        bottom: -28px;
    }

    .anim-container {
        width: 100%;
        display: flex;
        flex-grow: 1;
    }

    .anim-content {
        max-width: 250px;
    }
}

</style>
